import { Link, Outlet, useLocation } from "@tanstack/react-router";

const TABS = [
  { to: "/settings/verein", label: "Verein" },
  { to: "/settings/rechnungen", label: "Rechnungen" },
  { to: "/settings/template", label: "Rechnungs-Template" },
  { to: "/settings/abo", label: "Abo & Rechnungen" },
] as const;

export function SettingsLayout() {
  const { pathname } = useLocation();

  function isActive(to: string): boolean {
    return pathname === to || pathname.startsWith(to + "/");
  }

  return (
    <div className="max-w-3xl">
      <div className="mb-6">
        <h2 className="text-xl font-semibold tracking-tight">Einstellungen</h2>
      </div>

      <div className="border-b border-slate-200 mb-8">
        <nav className="flex gap-6 overflow-x-auto overflow-y-hidden no-scrollbar">
          {TABS.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              className={
                "py-3 text-sm font-medium border-b-2 -mb-px transition whitespace-nowrap " +
                (isActive(t.to)
                  ? "border-slate-900 text-slate-900"
                  : "border-transparent text-slate-500 hover:text-slate-900")
              }
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
